import React from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { initBrowserEvents } from '@nerdwallet/analytics';
import { setSentryClient } from '@nerdwallet/logging';
import * as Sentry from '@sentry/browser';

import history from './lib/history';

import routes from './routes';

import '@nerdwallet/base-styles/reset.css';
import '@nerdwallet/base-styles/base.css';
import './styles/main.less';

initBrowserEvents();
setSentryClient(Sentry);

export default () => (
  <ConnectedRouter history={history}>{routes}</ConnectedRouter>
);
